module.exports = __webpack_public_path__ + "static/media/mail001.6d813b4b.jpg";